export enum ConnectionType {
  SoapService = 0,
  RestBasicAuth = 1,
  RestOAuth = 2,
  File = 3,
  None = 4,
}
